import SeminarContactForm from './SeminarContactForm'
export default SeminarContactForm